export const Construct_code_category = [
  { construct: "Confidence", code: "con", category: "Student Learning" },
  { construct: "Student Habits", code: "sth", category: "Student Learning" },
  { construct: "Stress", code: "abur", category: "Student Learning" },
  { construct: "Motivation", code: "mot", category: "Student Learning" },
  { construct: "Resilience", code: "res", category: "Student Learning" },
];


export const studentAliasMap = {
  // "Zariel Galaviz": "Theon Greyjoy",
  // "Liat Aberman": "Tyrion Lannister",
  // "Kayden Jones": "Stannis Baratheon",
  // "Alayna Smith": "Ygritte",
  // "Britney Johnston": "Arya Stark",
  // "Jaelinjoy Chavez": "Brienne Tarth",
  // "Shawn Anthony Collado": "Jaime Lannister",
  // "Lana Wilson": "Cersei Lannister",
  // "Leya Dow": "Jon Snow",
  // "Adrienne Bautista": "Sansa Stark",
  // "Octavio Varela Segovia": "Eddard Stark",
  "Zoie Becker": "Neville Longbottom",
  "Eric Falcon Ledezma": "Luna Lovegood",
  "Tamiyah Hill": "Ginny Weasley",
  "Monica Pacheco": "Harry Potter",
  "Alec Plotegher": "Ron Weasley",
  "Wangtianjiao Cheng": "Hermione Granger",
  "Amya Johnson-Turpin": "Draco Malfoy",
};